import React, { useEffect, useMemo, useState } from "react";
import useRedux from "redux/useRedux";
import { t } from "i18next";
import dummy from "assets/images/dummy/1.png";
import { getHeaderUrlImg } from "redux/global/globalActions";
import { uAPI } from "api/config";
import FroalaEditorView from "components/reuseable/FormInput/FroalaEditorTextArea";
import { useSelector, useDispatch } from "react-redux";
import Delayed from "components/reuseable/Delayed";
import BasicModal from "components/reuseable/Modal/BasicModal";
import FileViewer from "react-file-viewer";
import { Link, useOutletContext , useLocation, useNavigate } from "react-router-dom";
import {
  getPengadaan,
  resetPengadaan,
  getFileById
} from "redux/pengadaan/pengadaanActions";
import { downloadFile, getFileExtension } from "utils/myFunc";
import File from "./file";


const Pengadaan = () => {
    // console.log("TERPANGGIL")
    const lang = localStorage.getItem("i18nextLng")
    let selector = useSelector((state)=>state.pengadaan);
    const [header, setHeader] = useState("");
    // console.log("SELECTOR",selector)
    const {
        dispatch,
        pengadaan: { data, fileById },
        global: {
            footer,
            // menuSidebar,
            headerUrlImg
        }
    } = useRedux();
    
    // const { title, id, title_en, description, description_en} = useOutletContext();
  const location = useLocation();
    useEffect(() => {
        dispatch(getHeaderUrlImg());
    }, [location])

    useEffect(() => {
        if (!headerUrlImg) return;
    
        const found = headerUrlImg?.find((va) => va.image_name === "Pengadaan");
    
        if (found) {
            console.log("Dapet Found :", found)
        setHeader(found); // bisa juga setHeader(found.image) kalau kamu hanya butuh url-nya
        }
    }, [headerUrlImg]);

    useEffect(() => {
        if (data) {
            dispatch(
                getPengadaan()
            );
            let paramsFile = "?id_category="+1;
            dispatch(getFileById(paramsFile));
        }
        return () => {
            dispatch(resetPengadaan());
            dispatch(getFileById())
        };
    }, [location, dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  const [show, setShow] = useState(false);
  const [showDetail, setShowDetail] = useState("");

//   const lihatPengadaan = (data) => {
//     setShow(true);
//     setShowDetail(uAPI + data?.pengadaan);
//   };
  // const unduh = (data) => {
  //     window.open(uAPI + data?.pengadaan, '_blank')
  // }

  const errorComponent = () => {
    return <>errorComponent</>;
  };

  const onError = () => {
    console.log("onError");
  };
// console.log("PENGADAAN DATA", data)
// console.log("FILEID", fileById)
  return (
    <>
    <div className="mt-[110px]">
    {/* ===== Awal Banner Title ===== */}
        {/* <div className={`bg-profil flex flex-col justify-center items-center`}>
            <div className="text-white text-[40px] font-semibold uppercase">
                {t('kontak')}
            </div>
        </div> */}
        <div className="slideshow-header w-screen h-screen relative overflow-hidden">
        {/* Teks di tengah */}
        <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center z-10">
            <div className="text-white text-[40px] font-semibold uppercase text-center drop-shadow-lg">
            <div className="froala-view-wrapper">
            {
                header?.description && header.image_name === "Pengadaan" ? 
                <FroalaEditorView
                        model={lang === "en" ? (header?.description_en ? header?.description_en : header?.description) :header?.description}
                /> :
                <div className="text-white text-[40px] font-semibold uppercase">
                    {t('pengadaan')}
                </div>
            }
            </div>
            </div>
        </div>

        {/* Gambar background */}
        <img
            src={header?.image ? uAPI + header.image : dummy}
            alt="banner"
            className="w-screen h-screen object-cover absolute top-0 left-0"
            loading="lazy"   // 🟢 tambahkan lazy loading
        />
        </div>
        {/* ===== Akhir Banner Title ===== */}
        <div className="flex flex-row items-center justify-center">
            <div className="hTitle mb-6">{lang === "en" ? (selector?.data[0]?.title_en ? selector?.data[0]?.title_en : selector?.data[0]?.title) : selector?.data[0]?.title}</div>
        </div>
        <div className="flex flex-row px-5 md:px-20">
            {selector?.data[0]?.description && <FroalaEditorView model={lang === "en" ? (selector?.data[0]?.description_en ? selector?.data[0]?.description_en : selector?.data[0]?.description) : selector?.data[0]?.description} />}
        </div>
        <div className="flex justify-startpx-5 md:px-20 mt-6">
            <button
                onClick={() => window.open((data[0]?.link || "https://p-eproc.pelindo.co.id/"), "_blank")}
                className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-3 rounded-lg shadow-md transition"
            >
                {data[0]?.link || "Link E-Proc"}
            </button>
        </div>
        <File file={fileById}/>
      <BasicModal open={show} onClose={() => setShow(!show)}>
        {/* <iframe src={showDetail} style={{ width: '100%', height: '100%' }}></iframe> */}
        <Delayed waitBeforeShow={3000}>
          <FileViewer
            fileType={getFileExtension(showDetail)}
            filePath={showDetail}
            errorComponent={errorComponent}
            onError={onError}
          />
        </Delayed>
      </BasicModal>
    </div>
    </>
  );
}
export default Pengadaan